import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

import ConfirmationDialog from 'src/components/ConfirmationDialog';

import DataTable from 'src/components/DataTable';

import messages from './messages';

interface StandbyTableProps {
  users: Array<UCM.ApplicationType>;
  onUnselect: (user: UCM.ApplicationType) => void;
}

export default function StandbyTable({ users, onUnselect }: StandbyTableProps) {
  const { formatMessage } = useIntl();

  const columns: Array<{
    id: keyof UCM.ApplicationType | string;
    label: string | React.ReactNode;
  }> = useMemo(
    () => [
      {
        id: 'standbyList',
        label: formatMessage(messages.standbyUserColumnLabel),
        render: (_: Object, application: UCM.ApplicationType) => (
          <Typography variant="inherit">
            {application.id} - {application.fullName}
          </Typography>
        ),
      },
      {
        id: 'lastOnline',
        label: formatMessage(messages.lastLoginTimeColumnLabel),
        align: 'center',
        render: (_: Object, application: UCM.ApplicationType) => (
          <Typography variant="inherit">{application.lastLoginAt}</Typography>
        ),
      },
      {
        id: 'actions',
        label: '',
        align: 'center',
        render: (_: Object, application: UCM.ApplicationType) => (
          <ConfirmationDialog
            message={formatMessage(messages.removeConfirmMessage)}
            onConfirm={() => onUnselect(application)}
          >
            {(handleOpen) => (
              <Tooltip
                arrow
                title={formatMessage(messages.removeButtonTooltip)}
              >
                <div>
                  <IconButton disabled={users.length < 2} onClick={handleOpen}>
                    <DeleteForeverOutlinedIcon
                      fontSize="small"
                      color="primary"
                    />
                  </IconButton>
                </div>
              </Tooltip>
            )}
          </ConfirmationDialog>
        ),
      },
    ],
    [users.length, onUnselect],
  );

  return <DataTable columns={columns} rows={users} enabledFooter={false} />;
}
